















































































import Vue from "vue";
import { emailRules } from "../../helpers";

export default Vue.extend({
  data: () => ({
    genderInt: "",
    firstNameInt: "",
    lastNameInt: "",
    emailInt: "",
    emailRules: emailRules,
    nameRules: [
      (v: string) => !!v || "Ihr Name ist erforderlich.",
      (v: string) => v.length <= 50 || "Ihr Name ist zu lang.",
      (v: string) => v.length >= 2 || "Ihr Name ist zu kurz.",
    ],
    phoneInt: "",
    phoneRules: [
      (v: string) => !!v || "Sie müssen eine Telefonnummer angeben.",
      (v: string) =>
        /^\+?[-0-9 ()]+$/.test(v) ||
        "Bitte eine gültige Telefonnummer angeben.",
    ],
  }),
  props: {
    firstName: String,
    lastName: String,
    gender: String,
    phone: { type: String, default: "" },
    email: { type: String, default: "" },
    showPhone: {
      default: true,
      type: Boolean,
    },
    showEmail: {
      default: false,
      type: Boolean,
    },
  },
  created() {
    this.firstNameInt = this.firstName || "";
    this.lastNameInt = this.lastName || "";
    this.phoneInt = this.phone || "";
    this.genderInt = this.gender || "";
    this.emailInt = this.email || "";
  },
  methods: {
    emit(val: any) {
      this.$emit("updated-element", val);
    },
  },
});
